import styled from "styled-components";
import { colors } from "./../../../components/common/element/elements.js";

export const Styles = styled.div`
  /* Popular Course */
  .popular-course {
    border: 1px solid ${colors.border1};
    padding: 15px 20px 20px;
    border-radius: 5px;
    h5 {
      color: ${colors.black1};
      font-weight: 600;
      padding-bottom: 7px;
      margin-bottom: 20px;
      display: inline-block;
      position: relative;

      &:before {
        position: absolute;
        content: "";
        background: ${colors.red};
        width: 80%;
        height: 2px;
        bottom: 0;
        left: 0;
      }

      @media (max-width: 575px) {
        font-size: 17px;
      }
    }

    .popular-items {
      .item-box {
        display: flex;
        align-items: center;
        margin-bottom: 15px;

        .item-img {
          flex-shrink: 0;
          width: 85px;
          display: flex;
          align-items: center;
          justify-content: center;

          a {
            display: inline-block;

            img {
              height: auto;
              width: auto;
              max-height: 70px;
              max-width: 85px;
              border-radius: 5px;
              margin-right: 15px;
              object-fit: contain;
              background-color: #f8f8f8;

              @media (max-width: 1199px) {
                max-height: 60px;
                max-width: 60px;
                margin-right: 12px;
              }
            }
          }
        }

        .item-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    .plus-icon {
      color: ${colors.red};
      font-weight: 700;
      font-size: 19px;
      margin-right: 8px;
      line-height: 1;
      flex-shrink: 0;
      align-self: flex-start;
      margin-top: 1.5px;
    }

    .university-title {
      font-weight: 700 !important;
      color: ${colors.black1} !important;
      margin-bottom: 6px;
      line-height: 1.1;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;

      a {
        color: inherit !important;
        font-weight: 600 !important;
        font-size: 1.2rem !important;
        &:hover {
          color: ${colors.red} !important;
        }
      }
    }

    .university-summary {
      font-size: 12px;
      color: ${colors.text3};
      margin-bottom: 0;
    }

    .loading,
    .empty {
      font-size: 13px;
      color: ${colors.text3};
      margin-bottom: 0;
    }

    .error {
      font-size: 13px;
      color: ${colors.red};
      margin-bottom: 0;
    }

    @media (max-width: 1199px) {
      padding: 12px 15px 15px;
    }
  }

  .popular-course + .popular-course {
    margin-top: 1rem;
  }
`;
